import React from "react";
import {
    Disclosure,
    DisclosureGroup,
    DisclosurePanel,
    Heading,
} from "react-aria-components";

import { FAQBlock as FAQBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";
import { slugify } from "@thelabnyc/thelabui/src/utils/text";

import { BlockComponentProps } from "../../utils/types";
import { Clickable } from "../Clickables";
import { RichText } from "../RichText";
import { Svg } from "../Svg";
import { ThemedModule } from "../ThemedModule";

import styles from "./FAQ.module.scss";

export const FAQ = ({
    value,
    index: blockIndex,
}: BlockComponentProps<FAQBlockValue>) => {
    return (
        <ThemedModule theme={value.module_theme}>
            <section className={styles.root}>
                <DisclosureGroup
                    allowsMultipleExpanded
                    className={styles.disclosureGroup}
                >
                    {value.items?.map((item, index) => (
                        <Disclosure
                            key={index}
                            id={`faq-${index}`}
                            className={styles.disclosure}
                        >
                            {({ isExpanded }) => (
                                <>
                                    <Heading
                                        level={3}
                                        className={styles.heading}
                                    >
                                        <Clickable
                                            slot="trigger"
                                            className={styles.trigger}
                                            data-click-type={
                                                isExpanded
                                                    ? undefined
                                                    : "accordion"
                                            }
                                            data-track-label={
                                                isExpanded
                                                    ? undefined
                                                    : `${blockIndex}-${slugify(item.question ?? "unknown")}-${index}`
                                            }
                                        >
                                            <span className={styles.question}>
                                                {item.question}
                                            </span>
                                            <Svg
                                                name="triangle"
                                                className={concatClassNames([
                                                    styles.arrow,
                                                    isExpanded
                                                        ? styles.expanded
                                                        : null,
                                                ])}
                                            />
                                        </Clickable>
                                    </Heading>
                                    <DisclosurePanel className={styles.panel}>
                                        <div className={styles.answer}>
                                            {item.answer && (
                                                <RichText value={item.answer} />
                                            )}
                                        </div>
                                    </DisclosurePanel>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </DisclosureGroup>
            </section>
        </ThemedModule>
    );
};
